import { render, staticRenderFns } from "./getCupons.vue?vue&type=template&id=25a3ac52&scoped=true"
import script from "./getCupons.vue?vue&type=script&lang=js"
export * from "./getCupons.vue?vue&type=script&lang=js"
import style0 from "./getCupons.vue?vue&type=style&index=0&id=25a3ac52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3ac52",
  null
  
)

export default component.exports